// The extension's content script sets attributes on <html>:
//   data-tidygolinks-ext="true"            — extension is installed here (any version)
//   data-tidygolinks-ext-signed-in="true"  — chrome.storage has a token here  (v3.6+)
//   data-tidygolinks-ext-signed-in="false" — chrome.storage has NO token here (v3.6+)
//   (attribute absent)                     — old extension (≤v3.5) doesn't know about this
// All per-browser (the content script can only see THIS browser's state).
// Polling lets us catch the attrs appearing after page load (content script
// runs at document_idle, and the signed-in attr is set from an async
// storage read).

export type ExtensionSignInState = 'yes' | 'no' | 'unknown';

export function hasExtension(): boolean {
  return document.documentElement.getAttribute('data-tidygolinks-ext') === 'true';
}

export function extensionSignInState(): ExtensionSignInState {
  const v = document.documentElement.getAttribute('data-tidygolinks-ext-signed-in');
  if (v === 'true') return 'yes';
  if (v === 'false') return 'no';
  return 'unknown';
}

export function waitForExtension(timeoutMs = 1500): Promise<boolean> {
  if (hasExtension()) return Promise.resolve(true);
  return new Promise(resolve => {
    const start = Date.now();
    const tick = () => {
      if (hasExtension()) return resolve(true);
      if (Date.now() - start >= timeoutMs) return resolve(false);
      setTimeout(tick, 100);
    };
    tick();
  });
}

// Resolves as soon as the signed-in attr becomes 'yes' or 'no'. If it stays
// absent past the timeout (old extension), resolves to 'unknown' so callers
// can apply a fallback.
export function waitForSignInState(timeoutMs = 500): Promise<ExtensionSignInState> {
  const initial = extensionSignInState();
  if (initial !== 'unknown') return Promise.resolve(initial);
  return new Promise(resolve => {
    const start = Date.now();
    const tick = () => {
      const state = extensionSignInState();
      if (state !== 'unknown') return resolve(state);
      if (Date.now() - start >= timeoutMs) return resolve('unknown');
      setTimeout(tick, 100);
    };
    tick();
  });
}
